/* eslint-disable react/no-danger */
// Man, I'm a bad, bad dev
// https://reactjs.org/docs/dom-elements.html#dangerouslysetinnerhtml
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { isMobileOnly } from 'react-device-detect';
import { useTranslation } from 'react-i18next';
import Button from '../common/Button';
import Footer from '../common/Footer';

const SingleChoice = ({
  body, buttons, onClick,
}) => {
  const { t } = useTranslation();
  useEffect(() => {
    document.body.classList.toggle('gray-5');
    // unmount:
    return () => { document.body.classList.toggle('gray-5'); };
  }, []);

  const handleClick = (event) => {
    event.preventDefault();
    const { target } = event;
    const button = buttons.find(x => x.label === target.name);
    onClick(button);
  };

  const getBodyMarkup = () => ({ __html: body });

  return (
    <>
      <div className="container mb-4">
        <p dangerouslySetInnerHTML={getBodyMarkup()} />
      </div>
      <div className={isMobileOnly ? 'fixed-bottom' : 'container text-center'}>
        <Button
          name={buttons[0].label}
          label={`${t('common.iAmAware')}, ${buttons[0].label}`}
          onClick={handleClick}
          cssClass={isMobileOnly ? 'btn btn-block' : 'btn min-width'}
        />
      </div>
      <Footer />
    </>
  );
};

SingleChoice.propTypes = {
  body: PropTypes.string.isRequired,
  buttons: PropTypes.arrayOf(PropTypes.any).isRequired,
  onClick: PropTypes.func.isRequired,
};

SingleChoice.defaultProps = {
};

export default SingleChoice;
